import { render, staticRenderFns } from "./PbDashboardFilters.vue?vue&type=template&id=64df9870&scoped=true&"
import script from "./PbDashboardFilters.vue?vue&type=script&lang=js&"
export * from "./PbDashboardFilters.vue?vue&type=script&lang=js&"
import style0 from "./PbDashboardFilters.vue?vue&type=style&index=0&id=64df9870&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64df9870",
  null
  
)

export default component.exports